import $ from 'jquery'

$(document).on(
  'click',
  '[data-behaviour="report-comment-link"]',
  function (event) {
    event.stopPropagation()
    event.preventDefault()

    $('.navbar-fixed-top .nav-collapse.collapse').collapse('hide')

    const link = $(event.target).closest('a')

    if ($('#report-comment').html().length > 0) {
      $('#report-comment').empty()
    } else {
      $.getScript(link.attr('href'))
    }
  }
)
